module.exports = __webpack_public_path__ + "img/lwl_xxxx.0abd2a16.png";